var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
var MobileBrandBar = /** @class */ (function (_super) {
    __extends(MobileBrandBar, _super);
    function MobileBrandBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        return _this;
    }
    MobileBrandBar.prototype.onUserUpdate = function () {
        this.loading = false;
    };
    Object.defineProperty(MobileBrandBar.prototype, "platform", {
        get: function () {
            var _a;
            return (_a = this.session.user) === null || _a === void 0 ? void 0 : _a.neighbourhood;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MobileBrandBar.prototype, "community", {
        get: function () {
            var _a;
            return (_a = this.session.user) === null || _a === void 0 ? void 0 : _a.community;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MobileBrandBar.prototype, "groupIdFromRoute", {
        get: function () {
            return parseInt(this.$route.params.groupId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MobileBrandBar.prototype, "groups", {
        get: function () {
            var _a;
            return (_a = this.session.user) === null || _a === void 0 ? void 0 : _a.groups;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MobileBrandBar.prototype, "groupFromSession", {
        get: function () {
            var _this = this;
            if (this.groups) {
                return this.groups.find(function (group) { return Number(group.id) === _this.groupIdFromRoute; });
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MobileBrandBar.prototype, "communityFromRoute", {
        get: function () {
            var _a;
            return ((_a = this.$route.meta) === null || _a === void 0 ? void 0 : _a.sideNav) === 'section-3';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MobileBrandBar.prototype, "logo", {
        get: function () {
            var _a, _b, _c;
            if (this.groupFromSession) {
                return ((_a = this.groupFromSession) === null || _a === void 0 ? void 0 : _a.logo_path) || '/favicon/mstile-70x70.png';
            }
            if (this.communityFromRoute) {
                return ((_b = this.community) === null || _b === void 0 ? void 0 : _b.logo_path) || '/favicon/mstile-70x70.png';
            }
            return ((_c = this.platform) === null || _c === void 0 ? void 0 : _c.logo_path) || '/favicon/mstile-70x70.png';
        },
        enumerable: false,
        configurable: true
    });
    MobileBrandBar.prototype.mounted = function () {
        this.$root.$on('groupLogoChanged', this.onGroupLogoChanged);
        this.$root.$on('platformLogoChanged', this.onPlatformLogoChanged);
        this.$root.$on('groupNameChanged', this.onGroupNameChanged);
    };
    MobileBrandBar.prototype.onGroupLogoChanged = function (path) {
        this.groupFromSession.logo_path = path;
    };
    MobileBrandBar.prototype.onPlatformLogoChanged = function (path) {
        this.platform.logo_path = path;
    };
    MobileBrandBar.prototype.onGroupNameChanged = function (path) {
        this.groupFromSession.name = path;
    };
    __decorate([
        Inject(),
        __metadata("design:type", Object)
    ], MobileBrandBar.prototype, "session", void 0);
    __decorate([
        Watch('session.user'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MobileBrandBar.prototype, "onUserUpdate", null);
    MobileBrandBar = __decorate([
        Component
    ], MobileBrandBar);
    return MobileBrandBar;
}(Vue));
export default MobileBrandBar;
